export default "__VITE_ASSET__6p9mvoJQ__"